var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`lang-${_vm.$i18n.locale} m-particles`},[_c('div',{staticClass:"absolute top-[12px] right-[16px] h-[24px] leading-[24px]"},[_c('the-dropdown-lang',{attrs:{"theme":"white"}})],1),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('div',{staticClass:"m-particles-background",attrs:{"id":"particles_js_bg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }